import { render, staticRenderFns } from "./DialogProfileUserAdd.vue?vue&type=template&id=6af24005&"
import script from "./DialogProfileUserAdd.vue?vue&type=script&lang=js&"
export * from "./DialogProfileUserAdd.vue?vue&type=script&lang=js&"
import style0 from "./DialogProfileUserAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6af24005')) {
      api.createRecord('6af24005', component.options)
    } else {
      api.reload('6af24005', component.options)
    }
    module.hot.accept("./DialogProfileUserAdd.vue?vue&type=template&id=6af24005&", function () {
      api.rerender('6af24005', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogProfileUserAdd.vue"
export default component.exports